import { PartnershipEmailMessages } from '../../content.types';

export const partnershipEmails: Record<string, PartnershipEmailMessages> = {
  default: {
    subject: 'Summer Health visit summary for {{patient_name}}',
    body: `Hello,

Please find attached the visit summary for {{patient_name}}.

Best,
Summer Health`,
  },
};
